import { Navigate } from "react-router-dom";

const HomePageTemplate = () => {
  return <Navigate to="/introducing" replace={true} />;
};
export default HomePageTemplate;
